module.exports = __webpack_public_path__ + "static/img/rank_115.b8c21e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_115.png
// module id = lCCO
// module chunks = 1